"use strict";
function relative(from, to) {
    if (!from || !to)
        throw new Error('Invalid or empty paths');
    if (from.startsWith('/') !== to.startsWith('/'))
        throw new Error('Mixed absolute and relative paths');
    let path = '';
    let current = from.substr(0, from.lastIndexOf('/') + 1);
    if (current === to)
        return './';
    while (!to.startsWith(current)) {
        const index = current.lastIndexOf('/', current.length - 2);
        if (index !== -1)
            path += '../';
        current = current.substr(0, index + 1);
        continue;
    }
    path += to.substr(current.length);
    return path;
}
module.exports = relative;
